import Iconify from "@/components/ui/Iconify";
import PostAvatar from "@/components/ui/PostAvatar";
import StaticVideoPreview from "@/components/ui/StaticVideoPreview";
import { useTranslations } from "@/lib/static-intl";
import Image from "next/image";
import { useState } from "react";

const PDW_HomeVisitorReviewsSection = ({
  place,
  placeTextReviews,
  setCurrentTab,
  handleContentModalOpen,
}) => {
  const t = useTranslations("places.place_details_window");
  const [placePosts] = useState(place?.postss || []);

  const renderPostMedia = (media) => {
    if (media?.mediaType?.includes("video")) {
      return (
        <StaticVideoPreview
          src={media?.filePath || "/sample-video.mp4"}
          className="object-cover w-full h-full"
        />
      );
    } else {
      return (
        <Image
          src={media?.filePath || "/person.png"}
          alt="sample"
          fill
          sizes="(max-width: 768px)100vw,(max-width: 1200px)50vw, 33vw"
          className="object-cover"
        />
      );
    }
  };

  if (!placePosts?.length && !placeTextReviews?.length) return null;
  return (
    <div className="w-full flex flex-col">
      <div className="w-fit flex items-center gap-2">
        <span className="font-semibold text-lg dark:text-white">
          {t("visitor reviews")}
        </span>
        <span className="font-bold text-lg text-black/30 dark:text-white/50">
          {placePosts?.length + placeTextReviews?.length}
        </span>
      </div>
      {placePosts?.length + placeTextReviews?.length > 0 ? (
        <div className="w-full flex flex-col divide-y divide-black/[0.08] dark:divide-white/[0.14] gap-3">
          {placePosts.map((post, i) => (
            <div key={i} className="w-full py-5 px-4 flex flex-col gap-3">
              <div className="w-full flex items-center gap-2">
                <PostAvatar
                  className={"!h-10 !min-w-10"}
                  src={post?.user?.profilePicture}
                />
                <span className="font-semibold">{post?.user?.username}</span>
              </div>
              <div className="flex gap-5">
                <div className="w-full flex flex-col">
                  <p className="tracking-tight leading-snug">{post?.title}</p>
                  <p className="tracking-tight leading-snug text-black/50">
                    {post?.description}
                  </p>
                </div>
                <div
                  className="relative rounded-md max-w-20 min-w-20 h-20 overflow-hidden"
                  onClick={(e) => handleContentModalOpen(e, post)}
                >
                  <div
                    className="absolute top-0 left-0 w-full h-full
                bg-black/0 z-20 hover:bg-black/20 transition duration-300 ease-in-out cursor-pointer"
                  />
                  {post?.mediaType?.includes("video") && (
                    <div className="absolute top-2 right-2 w-5 h-5 bg-black/10 backdrop-blur rounded-full z-20">
                      <Iconify
                        icon={"mynaui:play-solid"}
                        className={"!text-white"}
                      />
                    </div>
                  )}
                  {post?.media[0] ? (
                    <>{renderPostMedia(post?.media[0])}</>
                  ) : (
                    <Image
                      src={"/person.png"}
                      alt="food menu"
                      className={"object-cover"}
                      fill
                      sizes="(max-width: 768px)100vw,(max-width: 1200px)50vw, 33vw"
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
          {placeTextReviews?.slice(0, 1)?.map((_pl, i) => (
            <div
              key={_pl?._id || i}
              className="w-full flex flex-col gap-2 pt-2"
            >
              <div className="w-full flex items-center gap-2">
                <PostAvatar className={"!h-8 !min-w-8"} src={null} />
                <span className="font-semibold dark:text-white">
                  {_pl?.username}
                </span>
              </div>
              <div className="w-full flex flex-col">
                <pre className="font-sans text-wrap break-words tracking-tight leading-snug text-black dark:text-white text-sm">
                  {_pl?.review}
                </pre>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-2 items-center justify-center h-[300px]">
          <Image
            src={"/no-data.png"}
            alt="no-data"
            width={50}
            height={50}
            className="object-contain"
          />
          <span className="text-xs text-black/30 dark:text-white/30">
            {t("no visitor reviews")}
          </span>
        </div>
      )}

      <div className="w-full flex items-center mt-2">
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
        <button
          type="button"
          className="w-fit py-1.5 px-4 rounded-full bg-black/5 dark:bg-white/5 text-black/70 dark:text-white/70 text-sm flex items-center text-nowrap"
          onClick={() => setCurrentTab("Reviews")}
        >
          {t("see more reviews")}
          <Iconify
            icon={"lsicon:right-outline"}
            className={"!text-inherit !mt-0.5"}
          />
        </button>
        <div className="h-[1px] w-full bg-black/[0.08] dark:bg-white/[0.12]" />
      </div>
    </div>
  );
};

export default PDW_HomeVisitorReviewsSection;
